import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var Facebook = function Facebook(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 20 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 21 : _ref$height;
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    className: className,
    height: height,
    role: "presentation",
    viewBox: "0 0 20 21",
    width: width,
    children: [/*#__PURE__*/_jsx("title", {
      children: "Facebook"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M10.683 20.416h-9.58C.495 20.416 0 19.925 0 19.319V1.639C0 1.033.494.542 1.104.542h17.792c.61 0 1.104.491 1.104 1.097v17.68c0 .606-.494 1.097-1.104 1.097H13.8V12.72h2.6l.389-3h-2.99V7.805c0-.868.243-1.46 1.497-1.46h1.598V3.662c-.277-.037-1.225-.118-2.33-.118-2.304 0-3.881 1.397-3.881 3.964V9.72H8.076v3h2.607v7.696z"
    })]
  });
};

export default Facebook;